module.exports = {"data":{"site":{"siteMetadata":{"title":"MODE BEWUSST?! • Bund für Bildung e. V."}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 126
// module chunks = 60335399758886 114276838955818